module.exports = __webpack_public_path__ + "media/images/sp/stores/umeda/umeda_concept_02-e70fb77ba29a44b2449ee69e44fb3740.jpg";